import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useStates = (country_id) => useQuery({ queryKey: [`loc-states`, country_id], queryFn: async () => {
    if(!country_id) return
    const callback = await API.get(`/common/loc/countries/${country_id}/states`)
    return callback?.data
}, staleTime: 1000 * 60 * 60 * 24 * 7 , gcTime: 1000 * 60 * 60 * 24 * 14 })

export default useStates